import { render, staticRenderFns } from "./PresTableTags.vue?vue&type=template&id=58d8662c"
import script from "./PresTableTags.vue?vue&type=script&lang=js"
export * from "./PresTableTags.vue?vue&type=script&lang=js"
import style0 from "./PresTableTags.vue?vue&type=style&index=0&id=58d8662c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports